import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import UploadPhotoInput from '../../common/uploadPhotoForm/uploadPhotoInput';
import Icon, { GLYPHS } from '../../common/icon';

const BackgroundImage = ({ onChange, onContentChange, value, remove }) => (
  <div>
    <h3 className="c-heading c-heading--tiny u-mb-">Background image</h3>
    <div className={classnames('c-engagement-image-upload', { 'is-empty': !value })}>
      <button type="button" className="c-btn c-btn--blank c-engagement-image-upload__remove" onClick={remove}>
        <Icon glyph={GLYPHS.closeSmall} size="nano" />
      </button>
      <Icon className="c-engagement-image-upload__icon" glyph={GLYPHS.upload} />
      <UploadPhotoInput input={{ onChange, onContentChange, value }} maxWidth={1000}>
        {imageUrl => <img className="c-engagement-image-upload__img" src={imageUrl} alt="" />}
      </UploadPhotoInput>
    </div>
    <div className="zeta u-ph- u-mt--">
      For best results use image size of <b>410x96</b> w/o logo and <b>410x186</b> w/ logo.
    </div>
  </div>
);

BackgroundImage.propTypes = {
  onChange: PropTypes.func,
  onContentChange: PropTypes.func,
  remove: PropTypes.func,
  value: PropTypes.string,
};
BackgroundImage.defaultProps = {
  onChange: () => null,
  onContentChange: () => null,
  remove: () => null,
  value: null,
};

export default BackgroundImage;
